import React from "react";
import "../static/css/bind-wexin.scss";
import { COURSE, COURSE_API } from "../utils/Req";
import { Utils } from "../utils/Utils";
import { setUserStorage } from '../server/commonFun';

const url = `https://open.weixin.qq.com/connect/qrconnect?appid=wx9b8434fed9a35dd8&redirect_uri=https%3a%2f%2fwww.putaoabc.com%2fai_course%2f%23%2fbind-weixin&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e&href=${encodeURIComponent(
  window.location.origin + window.publicUrl + "static/css/weixin.css"
)}#wechat_redirect`;

export default class BindWeixin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      offBind: false,
      offBinded: false,
      binded: false,
      hasWX: "",
      name: "",
      errmsg: ""
    };

    this.PutaoID = Utils.getCookie("putaoid");
    this.Token = encodeURIComponent(Utils.getCookie("token"));

    this.hashChangeHandler = this.hashChangeHandler.bind(this);
  }

  componentDidMount() {
    this.getUserInfo();

    this.addHashChangeHandler();

    this.hashChangeHandler();
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.hashChangeHandler);
    clearTimeout(this.timeOut);
  }

  addHashChangeHandler() {
    window.addEventListener("hashchange", this.hashChangeHandler, false);
  }

  // 获取用户信息
  getUserInfo() {
    // 发送请求判断是否已经绑定了微信，如果已经绑定了就显示已绑定微信。没有绑定就显示二维码
    // 下面的开关，如果点击关闭，就到解绑

    const req = `${COURSE_API.user}?putaoid=${this.PutaoID}&token=${
      this.Token
      }&from=pc`;

    fetch(req, { method: "GET" })
      .then(res => res.json())
      .then(data => {
        console.log(data);
        if (data.code === 499) {
          window.location = `${window.location.pathname}${window.location.search}#/login?redirect=bind-weixin`;
        } else if (data.code === 200) {
          this.setState({
            hasWX: data.hasWX,
            binded: true,
            name: data.nickname
          }, () => {
            setUserStorage(data);
          });
        }
      });
  }

  hashChangeHandler() {
    this.wx_code = Utils.getHashQueryString("code");
    this.wx_state = Utils.getHashQueryString("state");

    if (this.wx_code && this.wx_state) {
      const req = `${COURSE_API.bind_wx}?putaoid=${this.PutaoID}&token=${
        this.Token
        }&from=pc&code=${this.wx_code}&state=${this.wx_state}`;
      fetch(req, { method: "GET" })
        .then(res => res.json())
        .then(data => {
          console.log("绑定微信", data);
          if (data.code === 499) {
            window.location = `${window.location.pathname}${window.location.search}#/login?redirect=bind-weixin`;
          } else if (data.code === 471) {
            this.setState({
              errmsg: "微信号已绑定"
            });

            this.timeOut = setTimeout(() => {
              this.setState({
                errmsg: ""
              });
            }, 3000);
          } else if (data.code === 200) {
            window.location = `${window.location.pathname}${window.location.search}#/bind-weixin`;
            window.location.reload();
          }
        });
    }
  }

  unbindWxHandler() {
    const req = `${COURSE_API.unbind_wx}?putaoid=${this.PutaoID}&token=${
      this.Token
      }&from=pc`;
    fetch(req, { method: "GET" })
      .then(res => res.json())
      .then(data => {
        console.log(data);
        if (data.code === 499) {
          window.location = `${window.location.pathname}${window.location.search}#/login?redirect=bind-weixin`;
        } else if (data.code === 200) {
          this.setState({ offBind: false, offBinded: true });
        }
      });
  }

  bindClickHandler() {
    this.getUserInfo();
    this.setState({ offBind: false });
  }

  render() {
    const { offBind, errmsg, offBinded, name, hasWX } = this.state;
    return (
      <div className="weixin-bind">
        <div className="skyBg" />
        <div className="go-back" onClick={() => { window.history.back(); }} />
        {!offBind &&
          (hasWX === 1 ? (
            <div className="weixin-bind-container bind">
              <div className="weixin-bind-title">{name ? name : ""}</div>
              <div className="weixin-bind-content">
                {offBinded ? "已解除绑定" : "已绑定微信"}
              </div>
              <div
                className="check-box"
                // 点击解除绑定
                onClick={() => {
                  // !offBinded && this.setState({ offBind: true });
                  !offBinded
                    ? this.setState({ offBind: true })
                    : this.bindClickHandler();
                }}
              >
                <div
                  className={
                    !offBinded
                      ? "check-box-button checked"
                      : "check-box-button"
                  }
                />
              </div>
            </div>
          ) : (
              <div className="weixin-bind-container bind">
                <div className="weixin-bind-title">{name ? name : ""}</div>
                <iframe
                  title="bingWX"
                  style={{ marginTop: "20px", border: "none", height: "80%" }}
                  src={url}
                />
              </div>
            ))}
        {offBind && (
          <div className="weixin-bind-container unbind">
            <div className="weixin-unbind-title">解绑微信</div>
            <div className="weixin-unbind-content">
              解绑微信后您将无法使用微信登录、接收消息通知，确定要解绑吗？
              </div>
            <div className="weixin-unbind-button">
              <div
                className="weixin-unbind-button-cancle"
                // 取消解除绑定
                onClick={() => {
                  this.setState({
                    offBind: false
                  });
                }}
              >
                取消
                </div>
              <div
                className="weixin-unbind-button-sure"
                //  解除绑定
                onClick={() => {
                  this.unbindWxHandler();
                }}
              >
                确定
                </div>
            </div>
          </div>
        )}
        {errmsg && <div className="errmsg-toast"> {errmsg}</div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/route/BindWeixin.js